import { render, staticRenderFns } from "./ORDsManagerLandingPage.vue?vue&type=template&id=56b4b99c&"
import script from "./ORDsManagerLandingPage.vue?vue&type=script&lang=js&"
export * from "./ORDsManagerLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports